import type { ContactItemType } from '../../templates';

const STARTABLE_STATES: Set<LatestContactStateEnum> = new Set([
  'NO_STATE',
  'AI_FAILED',
  'AI_READY_TO_START',
  'AI_ACTIVE',
]);

export const canStart = (c: ContactItemType, meta: AppMetaType) => {
  const state = c.latest_contact_state as LatestContactStateEnum;
  const campaignActive =
    meta.campaignsMap[c.campaign_id]?.status !== 'inactive';

  return campaignActive && (!state || STARTABLE_STATES.has(state));
};
